
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  methods: {
    translateText: async function (ev) {
      const self = this;
      const l = this.$(ev.target).data('lng');
      this.translated = this.translated || {};
      this.translated[l] = !!!this.translated[l];

      for (let i in this.translated) {
        if (i !== l) {
          this.translated[i] = false;
          this.$('.button-translate-' + i).attr('src', 'static/img/flag_' + i + '.png');
        }
      }

      if (this.translated[l]) {
        this.$(ev.target).attr('src', 'static/img/flag_translate.png'); // traduce

        this.$('.build-text').text('I\'m translating ...');
        const APIKey = 'AIzaSyB8AY9p2GiPEq4iQ7gNmh5IRqI7MfKyy28';
        const url = 'https://translation.googleapis.com/language/translate/v2?key=' + APIKey;
        const data = {
          target: self.$(ev.target).data('lng'),
          q: [self.event.description || '', self.event.text || ''],
          format: 'text'
        };
        const options = {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json'
          }
        };
        let res = await fetch(url, options);

        if (res.ok) {
          let resp = await res.json();
          self.$('.poi-edit-event-description').text(resp.data.translations[0].translatedText);
          self.$('.poi-edit-event-text').text(resp.data.translations[1].translatedText);
        } else {
          self.$('.poi-edit-event-description').text(self.event.description);
          self.$('.poi-edit-event-text').text(self.event.text);
        }
      } else {
        this.$(ev.target).attr('src', 'static/img/flag_' + l + '.png'); // torna a originale

        self.$('.poi-edit-event-description').text(self.event.description);
        self.$('.poi-edit-event-text').text(self.event.text);
      }
    },
    showImage: function (idx) {
      const sw = this.$app.swiper.get('.build-swiper-event');
      sw.slideTo(idx);
    },

    showVideo(ev) {},

    getEvent: function () {
      const id = this.$route.params.id;
      const idpoi = this.$route.params.poi;
      const self = this;
      const app = this.$app;
      myApp.server.get('poi/' + idpoi + '/other_experience/' + id).then(event => {
        return self.$setState({
          event: event
        });
      }).then(() => {
        const sw = app.swiper.get('.build-swiper-event');
        sw.update();
        self.$('video').forEach(el => {
          el.load();

          el.onplay = () => {
            if (el.requestFullscreen) {
              console.log('requestFullscreen');
              el.requestFullscreen();
            } else if (el.webkitRequestFullscreen) {
              /* Safari */
              console.log('webkitRequestFullscreen');
              el.webkitRequestFullscreen();
            }
          };
        });
      });
    },

    imgBrowser(idx) {
      const self = this,
            app = this.$app,
            $ = this.$;
      const photoBrowser = app.photoBrowser.create({
        photos: self.event.images
      });
      photoBrowser.open(idx);
    }

  },
  data: function () {
    return {
      lng: lng,
      event: {},
      images: [],
      idpoi: this.$route.params.poi
    };
  },
  on: {
    pageBeforeIn: function () {
      this.getEvent();
    }
  },
  id: '69c618661d',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page"> \n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="ios-only">Back</span>\n          </a>\n        </div>\n\n        <!-- <div class="right">\n          <a href="/booking/';
      r += c(ctx_1.idpoi, ctx_1);
      r += '/" class="button button-fill button-round bg-imc text-color-yellow">';
      r += c(ctx_1.lng.book, ctx_1);
      r += '</a>\n        </div> -->\n\n      </div>\n    </div>\n\n    <div class="page-content page-content-banner poi-event-body" style="max-width: 100%; overflow-x: hidden;">\n      <div class=\'poi-event-title\'>';
      r += c(ctx_1.event.title, ctx_1);
      r += '</div>\n      <div class="build-slideshow">\n        <div class="build-swiper build-swiper-event swiper-container swiper-init">\n          <div class="swiper-wrapper">\n            ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.event.images, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="swiper-slide">\n              <div @click="imgBrowser(';
          r += c(data_2 && data_2.index, ctx_2);
          r += ')" class="contain build-slideshow-slide" style="background-image: url(';
          r += c(ctx_2, ctx_2);
          r += ');"></div>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          </div>\n        </div>\n      </div>\n\n      <div style="border-top: solid 1px #aaa; max-width: 100%; text-align: center">\n        ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.event.video, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n\n        <video class="video_cover build-image" \n               controls\n               style="background-image: url(';
          r += c(ctx_2.url, ctx_2);
          r += '?poster)">\n          <source src="';
          r += c(ctx_2.url, ctx_2);
          r += '" type="video/mp4"> \n        </video>\n\n        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n      </div>\n\n      <!-- TRANSLATE -->\n      <div style="height: 15px"></div>\n      <div class=\'translate-group\'>\n        <img @click="translateText" data-lng=\'en\' class="button-translate button-translate-en" src="static/img/flag_en.png" alt=""/>\n        <img @click="translateText" data-lng=\'fr\' class="button-translate button-translate-fr" src="static/img/flag_fr.png" alt=""/>\n        <img @click="translateText" data-lng=\'it\' class="button-translate button-translate-it" src="static/img/flag_it.png" alt=""/>\n        <img @click="translateText" data-lng=\'es\' class="button-translate button-translate-es" src="static/img/flag_es.png" alt=""/>\n        <img @click="translateText" data-lng=\'de\' class="button-translate button-translate-de" src="static/img/flag_de.png" alt=""/>\n      </div>\n\n      <div class=\'block\'>\n        <div class="poi-edit-event-description">';
      r += c(ctx_1.event.description, ctx_1);
      r += '</div>\n      </div>\n      <div class=\'block\'>\n        <div class="poi-edit-event-text">';
      r += c(ctx_1.event.text, ctx_1);
      r += '</div>\n      </div>\n    </div>\n\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    